/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Guardian internal API
 * OpenAPI spec version: v1
 */
import {
  HttpClient
} from '@angular/common/http';

import {
  Injectable
} from '@angular/core';

import type {
  UserFrontPermissionsResponsePagedResult
} from '../../../interfaces/guardian';

import { guardianFetcher } from '../../../fetchers/guardian.fetcher';




// eslint-disable-next-line
    type ThirdParameter<T extends (...args: any) => any> = T extends (
  config: any,
  httpClient: any,
  args: infer P,
) => any
  ? P
  : never;

@Injectable({ providedIn: 'root' })
export class InternalGeneralService {
  constructor(
    private http: HttpClient,
  ) {}/**
 * @summary Синхронизирует роли, группы и API разрешения.
 */
 postApiGeneralSyncAll<TData = void>(
    
 options?: ThirdParameter<typeof guardianFetcher>) {
      return guardianFetcher<TData>(
      {url: `/api/general/syncAll`, method: 'POST'
    },
      this.http,
      options);
    }
  /**
 * @summary Возвращает список API-разрешений, доступных текущему пользователю на основе его ролей.
 */
 getApiGeneralUserFrontPermissions<TData = UserFrontPermissionsResponsePagedResult>(
    
 options?: ThirdParameter<typeof guardianFetcher>) {
      return guardianFetcher<TData>(
      {url: `/api/general/userFrontPermissions`, method: 'GET'
    },
      this.http,
      options);
    }
  };

export type PostApiGeneralSyncAllClientResult = NonNullable<void>
export type GetApiGeneralUserFrontPermissionsClientResult = NonNullable<UserFrontPermissionsResponsePagedResult>
